const config = {
    apiUrl: process.env.REACT_APP_API_URL || 'https://xuar-e6vh-cmcf.e2.xano.io/api:CpKwGPIS', 
    healthdata_apiUrl: process.env.REACT_APP_HEALTHDATA_API_URL || 'https://xuar-e6vh-cmcf.e2.xano.io/api:2K9hwDeK', 
    mailgunApiKey: process.env.REACT_APP_MAILGUN_API_KEY,
    mailgunBaseUrl: process.env.REACT_APP_MAILGUN_BASE_URL, 
    openaiApiKey: process.env.REACT_APP_OPENAI_API_KEY,
    openaiDefaultModel: process.env.REACT_APP_OPENAI_DEFAULT_MODEL || 'gpt-5-2025-08-07'
};

export default config; 